import { FLAG_ON, StorageKey } from '../lib/storageKeys';
import { readStorage } from '../lib/safeStorage';
import type { Services } from './services';

/**
 * Test hook for end-to-end tests and screenshots. When localStorage `wiztime.testHooks` is '1'
 * (a test sets it with `addInitScript`), `window.__wiztime` exposes the store and the database so
 * a test can seed or inspect data without driving the UI. It is checked at run time, not at
 * build time, so it also works on the production preview build the end-to-end tests use.
 */
export interface WizTimeTestHooks {
  readonly store: Services['store'];
  readonly db: Services['db'];
  readonly deviceId: string;
}

declare global {
  interface Window {
    __wiztime?: WizTimeTestHooks;
  }
}

export function installTestHooks(services: Services): void {
  if (readStorage(StorageKey.TestHooks) !== FLAG_ON) return;
  window.__wiztime = { store: services.store, db: services.db, deviceId: services.deviceId };
}
